__turbopack_context__.v({
  "impersonation-form": "impersonation-modal-module-scss-module__1pLgAW__impersonation-form",
  "impersonation-form__actions": "impersonation-modal-module-scss-module__1pLgAW__impersonation-form__actions",
  "impersonation-form__description": "impersonation-modal-module-scss-module__1pLgAW__impersonation-form__description",
});
